import { BRAND_PRODUCT_NAME } from "./brand.ts";
import type { GatewayHelloOk } from "./gateway.ts";

export const CONTROL_UI_DEMO_SERVER_VERSION = "demo";

export function isControlUiDemoMode(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    const url = new URL(window.location.href);
    const q = url.searchParams.get("demo");
    const hashParams = new URLSearchParams(url.hash.startsWith("#") ? url.hash.slice(1) : "");
    const h = hashParams.get("demo");
    const v = (q ?? h ?? "").trim().toLowerCase();
    return v === "1" || v === "true" || v === "yes" || v === "on";
  } catch {
    return false;
  }
}

export function isControlUiDemoHello(hello: GatewayHelloOk | null): boolean {
  return hello?.server?.version === CONTROL_UI_DEMO_SERVER_VERSION;
}

const DEMO_WELCOME_TEXT = `${BRAND_PRODUCT_NAME} · 演示模式：当前为静态界面预览，未连接真实网关。聊天与配置保存等需在本机安装 OpenClaw 并运行 gateway 后使用。`;

export function buildDemoHello(): GatewayHelloOk {
  return {
    type: "hello-ok",
    protocol: 3,
    server: { version: CONTROL_UI_DEMO_SERVER_VERSION, connId: "local-demo" },
    features: { methods: [], events: [] },
    auth: {
      role: "operator",
      scopes: ["operator.read", "operator.write", "operator.admin"],
    },
  };
}

export type ControlUiDemoApplyHost = {
  connected: boolean;
  hello: GatewayHelloOk | null;
  serverVersion: string | null;
  assistantName: string;
  lastError: string | null;
  chatMessages: unknown[];
  requestUpdate?: () => void;
};

export function applyControlUiDemoMode(host: ControlUiDemoApplyHost) {
  host.connected = true;
  host.hello = buildDemoHello();
  host.serverVersion = CONTROL_UI_DEMO_SERVER_VERSION;
  host.assistantName = BRAND_PRODUCT_NAME;
  host.lastError = null;
  const now = Date.now();
  host.chatMessages = [
    {
      role: "assistant",
      content: [{ type: "text", text: DEMO_WELCOME_TEXT }],
      timestamp: now,
    },
  ];
  host.requestUpdate?.();
}
